import { render, staticRenderFns } from "./NewTratamiento.vue?vue&type=template&id=2a1bb2f4&scoped=true&"
import script from "./NewTratamiento.vue?vue&type=script&lang=ts&"
export * from "./NewTratamiento.vue?vue&type=script&lang=ts&"
import style0 from "./NewTratamiento.vue?vue&type=style&index=0&id=2a1bb2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1bb2f4",
  null
  
)

export default component.exports